module.exports = __webpack_public_path__ + "static/media/MNISTpic.b04e9093.jpeg";